import React from 'react'

const Users = () => {
    return <>Users</>
}

export default Users
